import { FC } from 'react'
import clsx from 'clsx'
import { MatchingPayoutTicket } from '../../core/_models'
import { formatMatchSlots, getMatchBreakdownBadges } from '../../core/matchCountBreakdown'
import styles from './MatchCountCell.module.css'

interface Props {
  ticket: MatchingPayoutTicket
}

/**
 * Колонка «Кол-во матчей»: сверху занятость слотов чанков, ниже — исходы всех
 * матчей выплаты. Верхняя строка намеренно НЕ равна сумме бейджей: слот
 * освобождается, когда депозит просрочился или отменён, а в истории он остаётся.
 */
export const MatchCountCell: FC<Props> = ({ ticket }) => {
  const badges = getMatchBreakdownBadges(ticket.paymentTicketList)

  return (
    <div className='d-flex flex-column align-items-start gap-1'>
      <span className='fw-semibold'>
        {formatMatchSlots(ticket.liveMatchCount, ticket.maxMatchCount)}
      </span>
      {badges.map((badge) => (
        <span
          key={badge.bucket}
          className={clsx('badge', badge.className, badge.bucket === 'expired' && styles.expired)}
        >
          {badge.label} {badge.count}
        </span>
      ))}
    </div>
  )
}
